import './App.css'

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './Pages/Login';
import Dashboard from './Pages/Dashboard';
import Categories from './Pages/Categories';
import Category from './Pages/Category';
import Dishes from './Pages/Dishes';
import Dish from './Pages/Dish';
import Products from './Pages/Products';
import Product from './Pages/Product';
import Productsearch from './Pages/Productsearch';
import More from './Pages/More';
import QRCode from './Pages/QRCode';
import Result from './Pages/Result';
import Profile from './Pages/Profile';
import Terms from './Pages/Terms';
import Privacy from './Pages/Privacy';
import Explanation from './Pages/Explanation';
import Helpdesk from './Pages/Helpdesk';
import Scanner from './Pages/Scanner';
import ForgotPassword from './Pages/ForgotPassword';
import Register from './Pages/Register';
import ResetPassword from './Pages/ResetPassword';
import VerifyEmail from './Pages/VerifyEmail';
import Show from './Pages/Show';

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/register" element={<Register />} />
                <Route path="/reset-password/:resettoken" element={<ResetPassword />} />
                <Route path="/verify-email/:token" element={<VerifyEmail />} />
                <Route path="/show/:token" element={<Show />} />

                <Route path="/dashboard" element={<Dashboard />} />
                 
                <Route path="/categories" element={<Categories />} />
                <Route path="/category" element={<Category />} />
                <Route path="/dishes" element={<Dishes />} />
                <Route path="/dish" element={<Dish />} />
                <Route path="/products" element={<Products />} />
                <Route path="/product" element={<Product />} />
                <Route path="/component" element={<Product />} />
                <Route path="/productsearch" element={<Productsearch />} />
                <Route path="/more" element={<More />} />
                <Route path="/qr-code" element={<QRCode />} />
                <Route path="/result" element={<Result />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/explanation" element={<Explanation />} />
                <Route path="/helpdesk" element={<Helpdesk />} />
                <Route path="/feedback" element={<Helpdesk />} />
                <Route path="/scanner/:code" element={<Scanner />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
